import { PIMFormikRadio } from './PIMFormikRadio';

export default PIMFormikRadio;
